// @flow
export const supportedLocales = ['en', 'da', 'no', 'se'];
export const defaultLocale = 'da';
